import { useCallback, useRef } from "react";

const useAutoScroll = () => {
    const scrollFrameRef = useRef(null);
    const touchPositionRef = useRef(null);

    const startAutoScroll = useCallback(() => {
        // Stop any existing scroll animation
        if (scrollFrameRef.current) {
            cancelAnimationFrame(scrollFrameRef.current);
        }

        const performScroll = () => {
            if (!touchPositionRef.current) return;

            const viewportHeight = window.innerHeight;
            const scrollThreshold = 100;
            const scrollSpeed = 10;
            const { y } = touchPositionRef.current;

            // Scroll up when near top
            if (y < scrollThreshold) {
                window.scrollBy(0, -scrollSpeed);
            } 
            // Scroll down when near bottom
            else if (y > viewportHeight - scrollThreshold) {
                window.scrollBy(0, scrollSpeed);
            }

            // Continue scrolling if touch position is still valid
            if (touchPositionRef.current !== null) {
                scrollFrameRef.current = requestAnimationFrame(performScroll);
            }
        };

        scrollFrameRef.current = requestAnimationFrame(performScroll);
    }, []);

    const updateTouchPosition = useCallback((event) => {
        const clientY = 'touches' in event 
            ? event.touches[0].clientY 
            : (event ).clientY;
        
        touchPositionRef.current = { 
            x: 'touches' in event ? event.touches[0].clientX : (event).clientX, 
            y: clientY 
        };
    }, []);

    const stopAutoScroll = useCallback(() => {
        if (scrollFrameRef.current) {
            cancelAnimationFrame(scrollFrameRef.current);
            scrollFrameRef.current = null;
        }
        touchPositionRef.current = null;
    }, []);

    return { startAutoScroll, stopAutoScroll, updateTouchPosition };
};

export default useAutoScroll;